/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Note/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Edit from './Edit/index'
import No from './No/index'
import React from 'react'
import Read from './Read/index'



/** @type {import('Simple/types.js').View} */
export default function Note({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Expanded/Content/Notes/Notes/Content/Note"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let appointmentNoteIdValueData = fromData.useDataValue({ viewPath,
context: 'appointment_note',
path: 'id',
})
let editedNoteValueData = fromData.useDataValue({ viewPath,
context: 'edited_note',
})
let aggregateData = fromHelpers.getView(appointmentNoteIdValueData, editedNoteValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: aggregateData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Read'}>
<Read
  viewPath={`${viewPath}/Read`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Edit'}>
<Edit
  viewPath={`${viewPath}/Edit`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}